export const actuatorMimeTypes = [
  'application/vnd.spring-boot.actuator.v3+json',
  'application/vnd.spring-boot.actuator.v2+json',
  'application/vnd.spring-boot.actuator.v1+json',
  'application/json',
];
